import React, { useCallback, useEffect, useState } from 'react'
import './AddStaffTab.css'
import { Col, DatePicker, Radio, Row, Select } from 'antd'
import images1 from '../../assets/images1.jfif'
import { DownOutlined, UserOutlined, CaretDownOutlined, CameraOutlined } from '@ant-design/icons';
import { Button, Dropdown, message, Space, Tooltip } from 'antd';
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL,AddStaff, FetchDepartment, FetchDesignation, FetchLocation, FetchShifts, STAFF_ROLE, UploadFile } from '../../utils/constant';
import moment from 'moment';
import { useSelector } from 'react-redux';
function AddStaffTab() {
    const userInfo = useSelector((state) => state.signUp.signUpDetails);

    const [departmentList, setDepartmentList] = useState([]);
    const [departmentFullList, setDepartmentFullList] = useState([]);
    const [subDepartmentList, setSubDepartmentList] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [shiftList, setShiftList] = useState([]);
    const [locationList, setLocationList] = useState([]);
    const [staffDetails, setStaffDetails] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [staffNumber, setStaffNumber] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [permanentAddress, setPermanentAddress] = useState("");
    const [currentAddress, setCurrentAddress] = useState("");
    const [gender, setGender] = useState("");
    const [martialStatus, setMartialStatus] = useState("");
    const [dob, setDob] = useState(null);
    const [doj, setDoj] = useState(null);
    const [designation, setDesignation] = useState("");
    const [department, setDepartment] = useState("");
    const [subDepartmentId, setSubDepartment] = useState("");
    const [shift, setShift] = useState("");
    const [mainSite, setMainSite] = useState([]);
    const [weeklyOff, setWeaklyOff] = useState([]);
    const [isEditModeEnables, setIsEditModeEnables] = useState(null);
    const [logo, setLogo] = useState(null);
    const [staffTitle, setStaffTitle] = useState("Staff 1");
    const [genderOptions, setGenderOptions] = useState([
        { value: 'male', label: 'male' },
        { value: 'female', label: 'female' },
        { value: 'other', label: 'other' },
        
      ]);
    const [martialStatusOptions, setMartialStatusOptions] = useState([
        { value: 'single', label: 'single' },
        { value: 'married', label: 'married' }        
      ]);
 
    const [weekOffOptions, setWeekOffOptions] = useState([
        { value: 0, label: 'Sunday' },
        { value: 1, label: 'Monday' },
        { value: 2, label: 'Tuesday' },
        { value: 3, label: 'Wednesday' },
        { value: 4, label: 'Thursday' },
        { value: 5, label: 'Friday' },
        { value: 6, label: 'Saturday' },
        
      ]);
    const addFinalStaff = () => {
      // if (!logo  ) {
      //   // Display an error message or take appropriate action
      //       toast.error("Please add Logo.", {
      //           position: toast.POSITION.TOP_RIGHT,
      //         });
      //       return;
      //     }
        if (!firstName ) {
            // Display an error message or take appropriate action
            toast.error("Please fill First Name.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            return;
          }
        if ( !lastName ) {
            // Display an error message or take appropriate action
            toast.error("Please fill Last Name.", {
              position: toast.POSITION.TOP_RIGHT,
            });
            return;
          }
          if ( !gender  ) {
            // Display an error message or take appropriate action
            toast.error("Please fill Gender.", {
              position: toast.POSITION.TOP_RIGHT,
            });
            return;
          }
          if ( !phoneNumber ) {
            // Display an error message or take appropriate action
            toast.error("Please fill Phone Number.", {
              position: toast.POSITION.TOP_RIGHT,
              });
              return;
            }
            const phoneNumberRegex = /^[0-9+]{10}$/;
            if (!phoneNumberRegex.test(phoneNumber)) {
              // Display an error message for an invalid phone number
              toast.error('Please enter a valid phone number.', {
                position: toast.POSITION.TOP_RIGHT,
              });
              return;
            }
            if ( !designation  ) {
                // Display an error message or take appropriate action
                toast.error("Please fill Designation.", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                return;
              }
            if ( !department  ) {
              // Display an error message or take appropriate action
              toast.error("Please fill Department.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            return;
          }
       
          if ( !shift  ) {
              // Display an error message or take appropriate action
              toast.error("Please fill Shift.", {
                  position: toast.POSITION.TOP_RIGHT,
                });
              return;
            }
          if (  mainSite.length == 0 ) {
              // Display an error message or take appropriate action
              toast.error("Please fill Main Site.", {
                  position: toast.POSITION.TOP_RIGHT,
                });
              return;
            }
          
        console.log('nextstaffDetails',staffDetails)
        const token = localStorage.getItem('authToken');
        
        const dataToSend = {
          staffs: [{
            ...(logo && { logo }),
    ...(firstName && { firstName }),
    ...(lastName && { lastName }),
    ...(phoneNumber && { phoneNumber }),
    ...(gender && { gender }),
    ...(martialStatus && { martialStatus }),
    ...(dob && { dob }),
    ...(doj && { doj }),
    ...(currentAddress && { currentAddress }),
    ...(permanentAddress && { permanentAddress }),
    ...(department && { department }),
    ...(subDepartmentId && { subDepartmentId }),
    ...(designation && { designation }),
    ...(shift && { shift }),
    ...(mainSite && mainSite.length > 0 && { mainSite }),
    ...(weeklyOff && weeklyOff.length > 0 && { weeklyOff }),
          }],
        };
        
        console.log('dataToSend',dataToSend)
        // const parseToken = JSON.parse(token) || {};
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${AddStaff}`, {
          method: "POST",
          headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify(dataToSend),
        });
    
        console.log('CompanyData')
        if (response.ok) {
          const data = await response.json();
          toast.success('Staff Added Successfully', {
            position: toast.POSITION.TOP_RIGHT,
          });
          console.log('staffDetail',data)
          setLogo(null)
          setFirstName("")
          setLastName("")
          setPhoneNumber("")
          setGender("")
          setMartialStatus("")
          setDob(null)
          setDoj(null)
          setCurrentAddress("")
          setPermanentAddress("")
          setDepartment("")
          setSubDepartment("")
          setDesignation("")
          setShift("")
          setMainSite([])
          setWeaklyOff([])
          
        } else {
          const data = await response.json();
          console.log('staffDetail',data)
          console.log('data?.data?.index',data?.data?.index)
         
  
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          
           
       }
       };
    
        fetchData();
       
      }
      const handleStaffNumber = useCallback((value) => {
          console.log('value',value.target.value)
          setStaffNumber(() => value.target.value);
        }, []);
      const handleFirstName = useCallback((value) => {
          console.log('value',value.target.value)
          setFirstName(() => value.target.value);
        }, []);
      const handleLastName = useCallback((value) => {
          console.log('setLastName',value.target.value)
          setLastName(() => value.target.value);
        }, []);
      const handlePhoneNumber = useCallback((value) => {
          console.log('PhoneNumber',value.target.value)
          setPhoneNumber(() => value.target.value);
        }, []);
      const handlePermanentAddress = useCallback((value) => {
          console.log('PermanentAddress',value.target.value)
          setPermanentAddress(() => value.target.value);
        }, []);
      const handleCurrentAddress = useCallback((value) => {
          console.log('CurrentAddress',value.target.value)
          setCurrentAddress(() => value.target.value);
        }, []);
        const handleGender = useCallback((value) => {
          console.log('value',value)
          setGender(() => value);
        }, []);
        const handleMaritalStatus = useCallback((value) => {
          console.log('value',value)
          setMartialStatus(() => value);
        }, []);
        const handleDobChange = (date, dateString) => {
          console.log('Selected DOB:', dateString);
          console.log(' DOB:', date);
          setDob(date);
        };
        const handleDojChange = (date, dateString) => {
          console.log('Selected DOB:', dateString);
          console.log(' DOB:', date);
          setDoj(date);
        };
        const handleDesignation = useCallback((value) => {
          console.log('value',value)
          setDesignation(() => value);
        }, []);
        const handleWeekOff = useCallback((value) => {
          console.log('value',value)
          setWeaklyOff(() => value);
        }, []);      
        const handleDepartment = (value) => {
          console.log('value',value)
          console.log('departmentList',departmentFullList)
          const selectedDepartment = departmentFullList.find((dept) => dept.departmentId === value);
  console.log('selectedDepartment',selectedDepartment)
          // Update subDepartmentList based on the selected department
          if (selectedDepartment && selectedDepartment.subDepartments) {
            const subDepartments = selectedDepartment.subDepartments?.map((subDept) => ({
              value: subDept.subDeptId,
              label: subDept.subDeptName,
            }));
            setSubDepartmentList(subDepartments);
            setSubDepartment('');
          } else {
            // If no subDepartments found, set subDepartmentList as empty array
            setSubDepartmentList([]);
          }
          setDepartment( value);
        };
        const handleSubDepartment = useCallback((value) => {
          console.log('value',value)
          setSubDepartment(() => value);
        }, []);
        const handleShift = useCallback((value) => {
          console.log('value',value)
          setShift(() => value);
        }, []);
        const handleMainSite = useCallback((value) => {
          console.log('value',value)
          setMainSite(() => value);
        }, []);
        
        
        // const progressIdd = useUID();
  
        const handleUploadLogo = (e) => {
          const file = e.target.files[0];
          console.log('file',file)
          // console.log('progressIdd',progressIdd)
          if (file) {
            // Check if the file type is an image
            if (file.type.startsWith("image/")) {
                const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
                if (file.size <= maxSizeInBytes) {
                    // Get the file extension
                    const extension = file.name.split('.').pop().toLowerCase();
    
                    // Allowed file extensions
                    const allowedExtensions = ['png', 'jpg', 'jpeg'];
    
                    // Check if the file extension is allowed
                    if (allowedExtensions.includes(extension)) {
              const fetchData = async () => {
  
                const formData = new FormData();
                formData.append("files", file);   
                formData.append("folder", 'profilePhotos');   
                // formData.append("progressId", progressIdd);   
                
              
              const response = await fetch(`${BASE_URL}/${UploadFile}`, {
                method: "POST",
                
                body: formData,
              });
              
              if (response.ok) {
                const data = await response.json();
                console.log('data',data)
                setLogo(data?.data[0]);
                // setLogo(file);
                
              } else {
                const data = await response.json();
                toast.error(data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                console.log('errdata',data)
                   
               };
               
              
            };
            fetchData();
        } else {
            toast.error('Only PNG, JPG, and JPEG formats are allowed for the logo.', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    } else {
        toast.error('File size should be less than or equal to 2 MB.', {
            position: toast.POSITION.TOP_RIGHT,
        });
    }
  } else {
    toast.error('Select image only.', {
        position: toast.POSITION.TOP_RIGHT,
    });
  }
          }
        };
        const disabledDate = current => {
            // Disable future dates
            return current && current > moment().endOf('day');
          };
          function formatTimeWithAMPM(milliseconds) {
            const hours = Math.floor(milliseconds / 3600000);
            const minutes = Math.round((milliseconds % 3600000) / 60000);
          
            const formattedHours = hours % 12 || 12;
            const ampm = hours >= 12 ? 'PM' : 'AM';
          
            return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
          }
          useEffect(() => {

            getAllDropdownList();
          }, []);
          const getAllDropdownList = async () =>{
            const token = localStorage.getItem('authToken');
          
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('departmentt',activeLocations)
                 setDepartmentFullList(activeLocations)
                const departmentOption = activeLocations?.map((item) => ({
                  value: item.departmentId,
                  label: item.departmentName,
                }));
                console.log('departmentOption',departmentOption)
                setDepartmentList(departmentOption)
                
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            const fetchDesignationData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('designation',activeLocations)
                const designationOption = activeLocations?.map((item) => ({
                  value: item.designationId,
                  label: item.designationName,
                }));
                console.log('designationOption',designationOption)
                setDesignationList(designationOption)
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            const fetchShiftData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchShifts}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('shift',activeLocations)
                const shiftOption = activeLocations?.map((item) => ({
                  value: item.shiftId,
                  label: `${item.shiftFullName} (${formatTimeWithAMPM(item.shiftStartTime)} - ${formatTimeWithAMPM(item.shiftEndTime)})`
                //   label: item.shiftFullName,
                }));
                console.log('shiftOption',shiftOption)
                setShiftList(shiftOption)
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('shifterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            const fetchLocationData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchLocation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('shift',activeLocations)
                const locationOption = activeLocations?.map((item) => ({
                  value: item.locationId,
                  label: item.locationName1,
                }));
                console.log('locationOption',locationOption)
                setLocationList(locationOption)
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('shifterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
            await fetchDesignationData();
            await fetchShiftData();
            await fetchLocationData();
          }


    const handleButtonClick = (e) => {
        message.info('Click on left button.');
        console.log('click left button', e);
    };
    const handleMenuClick = (e) => {
        message.info('Click on menu item.');
        console.log('click', e);
    };
    const items = [
        {
            label: '1st menu item',
            key: '1',
            icon: <UserOutlined />,
        },
        {
            label: '2nd menu item',
            key: '2',
            icon: <UserOutlined />,
        },
        {
            label: '3rd menu item',
            key: '3',
            icon: <UserOutlined />,
            danger: true,
        },
        {
            label: '4rd menu item',
            key: '4',
            icon: <UserOutlined />,
            danger: true,
            disabled: true,
        },
    ];
    const menuProps = {
        items,
        onClick: handleMenuClick,
    };
    const [value, setValue] = useState(1);
    const onChange = (e) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };
    return (
        <div className='mr-5'>
        <ToastContainer position="top-right" autoClose={2000} />

            {/* <p className='Compulsory'>Compulsory Data (EID - E101)</p> */}
            <Row className='grid grid-cols-12 gap-3 items-start'>
                <Col className='col-span-6'>
                    <p className='text-[13px] text-[#4B8AEB] font-sbold !mt-4'>PERSONAL DETAILS</p>
                    <div className='bg-[#EDF3FD] rounded-[23px] pt-4 pb-3'>
                    <div className="text-center mt-1 mb-2">
                      <label className="w-[90px] h-[90px] bg-[#CDDEF9] flex items-center justify-center mx-auto rounded-2xl cursor-pointer overflow-hidden">
                        {!logo && <CameraOutlined className="text-[#4B8AEB]" />}
                        <input
                          type="file"
                          className="hidden"
                          accept="image/*"
                          onChange={handleUploadLogo}
                        />
                        {logo && (
                          <img
                            src={logo}
                            alt="company_logo"
                            className="overflow-hidden w-full h-full object-cover"
                          />
                        )}
                      </label>
                      <span className="font-sbold text-sm mb-0">Profile<span className='text-red-500'></span></span>
                    </div>
                        <p className='text-xs  text-[#CE0000] text-center'>This photo will used to mark attendance of the employee</p>

                        <div className='mt-3 grid grid-cols-12 gap-2 px-3'>
                            {/* <div className='staffEMpInputmain'>
                                <p className='e101'>E101</p>
                            </div> */}
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                            <label htmlFor="shift" className="text-sm mb-0">First Name<span className='text-red-500'>*</span>:</label>
                            <input
                              className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none"
                              type="text"
                              value={firstName}
                              onChange={handleFirstName}
                            />
                          </div> 
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                            <label htmlFor="shift" className="text-sm mb-0">Last Name<span className='text-red-500'>*</span>:</label>
                            <input
                              className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none"
                              type="text"
                              value={lastName}
                              onChange={handleLastName}
                            />
                          </div>   
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                            <label htmlFor="shift" className="text-sm mb-0">Gender<span className='text-red-500'>*</span>:</label>
                                <select
                                  required
                                  onChange={(e) => handleGender(e.target.value)}
                                  value={gender}
                                  className={`h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0 ${gender === "" ? "placeholder staffAttendForm mb-3" : "staffAttendForm mb-3"}`}
                                >
                                  <option value="" disabled selected>
                                    Gender
                                  </option>
                                  {genderOptions.map((item, index) => {
                                    return (
                                      <option
                                        value={item.value}
                                        className="text-[#6C94B4]"
                                        key={index}
                                        onClick={() => handleGender(item.value)}
                                      >
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                          </div>
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                        <label htmlFor="shift" className="text-sm mb-0">Phone number<span className='text-red-500'>*</span>:</label>
                                <input
                                  className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none"
                                  type="tel"
                                  value={phoneNumber}
                                  onChange={handlePhoneNumber}
                                  maxLength={10}
                                />
                          </div> 
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                        <label htmlFor="shift" className="text-sm mb-0">Martial Status:</label>
                                <select
                                  required
                                  onChange={(e) => handleMaritalStatus(e.target.value)}
                                  value={martialStatus}
                                  className={`h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0 ${martialStatus === "" ? "staffAttendForm placeholder mb-3" : "staffAttendForm mb-3"}`}
                                >
                                  <option value="" disabled selected>
                                    Marital status
                                  </option>
                                  {martialStatusOptions.map((item, index) => {
                                    return (
                                      <option
                                        value={item.value}
                                        className="text-[#6C94B4]"
                                        key={index}
                                        onClick={() => handleMaritalStatus(item.value)}
                                      >
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                          </div>
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                        <label htmlFor="shift" className="text-sm mb-0">Permanent Address:</label>
                                <input
                                  className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none"
                                  type="text"
                                  value={permanentAddress}
                                  onChange={handlePermanentAddress}
                                />
                          </div>
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                        <label htmlFor="shift" className="text-sm mb-0">Current Address:</label>
                                <input
                                  className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none"
                                  type="text"
                                  value={currentAddress}
                                  onChange={handleCurrentAddress}
                                />
                          </div>
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                        <label htmlFor="shift" className="text-sm mb-0">Date of Birth:</label>
                                <DatePicker
                                  className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none border-none !shadow-none"
                                  format="YYYY-MM-DD"
                                  onChange={handleDobChange}
                                  // defaultValue={dob ? moment(dob).locale('en') : null}
                                  value={dob ? dob : null}
                                  disabledDate={disabledDate}
                                />
                          
                          </div>
                          <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                        <label htmlFor="shift" className="text-sm mb-0">Date of Joining:</label>
                                <DatePicker
                                  className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none border-none !shadow-none"
                                  format="YYYY-MM-DD"
                                  onChange={handleDojChange}
                                  // defaultValue={dob ? moment(dob).locale('en') : null}
                                  value={doj ? doj : null}
                                  disabledDate={disabledDate}
                                />
                          
                          </div>
                            {/* <div className='ml-3'>
                                <input
                                    placeholder="Email (Optional)"
                                    className="add-text-input"
                                />
                            </div> */}
                        </div>
                    </div>
                </Col>

                <Col className='col-span-6'>
                    <p className='text-[13px] text-[#4B8AEB] font-sbold !mt-4'>WORK DETAILS</p>
                    <div className='bg-[#EDF3FD] rounded-[23px] pt-4 pb-3 px-3'>
                    <Row gutter={16} className='gap-2 px-3 grid-cols-12 grid'>
              {/* <Col span={8}> */}
              <div className="mb-3 col-span-4">
                <label htmlFor="shift" className="text-sm mb-0">Designation<span className='text-red-500'>*</span>:</label>
                <select
                  className={`h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0 ${designation === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}
                  required
                  onChange={(e) => handleDesignation(e.target.value)}
                  value={designation}
                >
                  <option value="" disabled selected>
                    Designation
                  </option>
                  {designationList.map((item, index) => {
                    return (
                      <option
                        value={item.value}
                        className="text-[#6C94B4]"
                        key={index}
                        onClick={() => handleDesignation(item.value)}
                      >
                        {item.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* </Col> */}
              {/* <Col span={8}> */}
              <div className="mb-3 col-span-4">
                <label htmlFor="department" className="text-sm mb-0">Department<span className='text-red-500'>*</span>:</label>
                <select
                  required
                  onChange={(e) => handleDepartment(e.target.value)}
                  value={department}
                  className={`h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0 ${department === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}
                >
                  <option value="" disabled selected>
                    Department
                  </option>
                  {departmentList.map((item, index) => {
                    return (
                      <option
                        value={item.value}
                        className="text-[#6C94B4]"
                        key={index}
                        onClick={() => handleDepartment(item.value)}
                      >
                        {item.label}
                      </option>
                    );
                  })}
                </select>
               </div>
              {/* </Col> */}
              {/* <Col span={8}> */}
              <div className="mb-3 col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                <label htmlFor="shift" className="text-sm mb-0">Sub Department:</label>
                <select
                  required
                  onChange={(e) => handleSubDepartment(e.target.value)}
                  value={subDepartmentId}
                  className={`h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0  ${subDepartmentId === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}>
                  <option value="" disabled selected>
                    Sub Department
                  </option>
                  {subDepartmentList?.map((item, index) => {
                    return (
                      <option
                        value={item.value}
                        className="text-[#6C94B4]"
                        key={index}
                        onClick={() => handleSubDepartment(item.value)}
                      >
                        {item.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* </Col> */}
            {/* </Row>
            <Row gutter={16}> */}
              {/* <Col> */}
              <div className="mb-3 col-span-8" style={{ display: "flex", flexDirection: "column" }}>
                <label htmlFor="shift" className="text-sm mb-0">Weekly Off:</label>
                  <Select
                    mode="multiple"
                    allowClear
                    className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0 multiSelecStaffAttend [&_.ant-select-selector]:!bg-transparent [&_.ant-select-selector]:!border-none [&_.ant-select-selector]:!shadow-none [&_.ant-select-selection-item]:!bg-[#EDF3FD]"
                    maxTagCount={2}
                    // defaultValue={weeklyOff.length > 0 ? [weeklyOff] : [] }
                    value={weeklyOff}
                    onChange={handleWeekOff}
                    options={weekOffOptions}
                  />
                {/* </Col> */}
              </div>
            </Row>

            <div className='text-slate-500 !px-4'>Optional Deatails</div>
            <Row gutter={16} className="multiSelecStaffAttend gap-2 px-4 grid grid-cols-12">
              <div className="mb-3 col-span-6">
                <label htmlFor="shift" className="text-sm mb-0">Shift<span className='text-red-500'>*</span>:</label>
                <select
                    required
                    onChange={(e) => handleShift(e.target.value)}
                    value={shift}
                    className={`h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0 ${shift === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}
                  >
                  <option value="" disabled selected>
                    Shift
                  </option>
                  {shiftList.map((item, index) => {
                    return (
                      <option
                        value={item.value}
                        className="text-[#6C94B4]"
                        key={index}
                        onClick={() => handleShift(item.value)}
                      >
                        {item.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="mb-3 col-span-6 flex flex-col">
                <label htmlFor="mainSite" className="!text-sm mb-0">Main Site<span className='text-red-500'>*</span>:</label>
                <Select
                  mode="multiple"
                  className="h-[55px] rounded-[28px] bg-[#CDDEF9] !px-4 outline-none !my-0 multiSelecStaffAttend [&_.ant-select-selector]:!bg-transparent [&_.ant-select-selector]:!border-none [&_.ant-select-selector]:!shadow-none [&_.ant-select-selection-item]:!bg-[#EDF3FD]"
                  allowClear
                  maxTagCount={2}
                  onChange={handleMainSite}
                  value={mainSite}
                  options={locationList}
                />
              </div>
            </Row>

                        {/* <div className='flex mt-2'>
                            <Dropdown menu={menuProps}>
                                <Button style={{ backgroundColor: '#ffffff', height: '44px', border: '2px solid #D1D2D3',borderRadius:'10px' }}>
                                    <Space style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                        Contractor Company
                                        <CaretDownOutlined style={{ fontSize: '9px' }} />
                                    </Space>
                                </Button>
                            </Dropdown>                           
                        </div> */}
                    </div>
                </Col>
            </Row>
            <div className='last-buton'>
                <Button className='bg-[#6198ED] rounded-full h-[52px] inline-flex items-center justify-center min-w-[155px] text-white !border-none'  onClick={addFinalStaff}>
                    <span className='text-sm'>Add Staff</span>
                </Button>
            </div>
        </div>
    )
}

export default AddStaffTab